/**
 * Bildregistry der Unterstuetzer:innen-Seite.
 *
 * Die Dateien liegen als AVIF (klein) und WebP (Fallback) in
 * src/assets/images/supporter/ und werden aus den Originalen im Drop-Ordner
 * mit scratchpad/build-fotos.sh erzeugt. Erzeugte Groessen: Galerie 900px
 * farbecht (30-57 KB), Hero 1600px als Graustufenbild (131 KB) - der Hero
 * bekommt sein Navy/Teal erst im CSS, seine Farbinformation waere verschenkt.
 *
 * Statische Importe statt dynamischer Pfade, weil der Webpack-Build von CRA
 * die Dateien nur so mitnimmt und mit Hash-Namen versieht.
 */

import heroAvif from '../../assets/images/supporter/hero.avif'
import heroWebp from '../../assets/images/supporter/hero.webp'

import messeModeAvif from '../../assets/images/supporter/messe-mode.avif'
import messeModeWebp from '../../assets/images/supporter/messe-mode.webp'
import messeUpcyclingAvif from '../../assets/images/supporter/messe-upcycling.avif'
import messeUpcyclingWebp from '../../assets/images/supporter/messe-upcycling.webp'
import siegerehrungAvif from '../../assets/images/supporter/siegerehrung.avif'
import siegerehrungWebp from '../../assets/images/supporter/siegerehrung.webp'
import messeTechnikAvif from '../../assets/images/supporter/messe-technik.avif'
import messeTechnikWebp from '../../assets/images/supporter/messe-technik.webp'
import europafinaleAvif from '../../assets/images/supporter/europafinale.avif'
import europafinaleWebp from '../../assets/images/supporter/europafinale.webp'
import gewinnerAvif from '../../assets/images/supporter/gewinner.avif'
import gewinnerWebp from '../../assets/images/supporter/gewinner.webp'

export const HERO_PHOTO = { avif: heroAvif, webp: heroWebp }

export const PHOTOS = {
	'messe-mode': { avif: messeModeAvif, webp: messeModeWebp },
	'messe-upcycling': { avif: messeUpcyclingAvif, webp: messeUpcyclingWebp },
	siegerehrung: { avif: siegerehrungAvif, webp: siegerehrungWebp },
	'messe-technik': { avif: messeTechnikAvif, webp: messeTechnikWebp },
	europafinale: { avif: europafinaleAvif, webp: europafinaleWebp },
	gewinner: { avif: gewinnerAvif, webp: gewinnerWebp }
}
